import { useState } from 'react'
import { createModel } from 'hox'
import { TablePaginationConfig } from 'antd/es/table/interface'
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, defaultMdCmParam } from '@/utils/constants'
import { IArchivesAssetsDetail, IUserControlDetail, IUserControlSearchFields, IAssetsDetail, userControlService } from './userControlService'
import { transPgToPagination } from '@/model/globalModel'
import { ISearchPage } from '@/types/AppTypes'
import { ModeType } from '@/model/navModel'
import { globalPrompt } from '@/components/message'

export const userControlModel = createModel(function () {
    //列表数据源
    const [dataSource, setDataSource] = useState<IUserControlDetail[]>([])
    //查询条件
    const [searchParam, setSearchParam] = useState<IUserControlSearchFields>({})
    //分页参数
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg)
    //表格多选id值
    const [selectedRowKeys, setSelectedRowKeys] = useState<any>({})
    //列表查询
    const loadData = async (page: ISearchPage = initPgCfg, searchValue: IUserControlSearchFields = searchParam) => {
        const searchParams = {
            ...searchValue,
            page: {
                pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
                pageNum: (page?.current || page?.pageNum) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
            },
            sourceApp: 'portal',
            status:0
        }
        let { retData } = await userControlService.page(searchParams)
        const { records, ...pg } = retData
        setPgCfg(transPgToPagination(pg))
        setDataSource(records)
    }
    //设置搜索value
    const updateSearchParam = (updateParam: IUserControlSearchFields) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }
    //重置搜索参数
    const resetSearchParam = () => {
        setSearchParam({})
        setSelectedRowKeys({})
        loadData(initPgCfg, {})
    }

    const initAddFormVal = {}
    //新增表单缓存
    const [addFormVal, setAddFormVal] = useState<any>(initAddFormVal)
    //编辑表单缓存
    const [editFormVal, setEditFormVal] = useState<any>({})
    const [userDetailVisible, setUserDetailVisible] = useState<boolean>(false)
    //表单新增修改
    const updateAddFormVal = (val: object | null) => {
        val ? setAddFormVal({ ...addFormVal, ...val }) : setAddFormVal(initAddFormVal)
    }
    //表单新增修改
    const updateEditFormVal = (val: object | null) => {
        val ? setEditFormVal({ ...editFormVal, ...val }) : setEditFormVal({})
    }

    //获取一条详情数据 Api
    const getOne = async (id: string) => {
        let { retData } = await userControlService.one(id)
        const { archivesAssets, ...formVal } = retData
        retData &&
            setEditFormVal({
                ...formVal,
                disableFlag: !formVal.disableFlag,
            })
    }

    //表单新增 Api
    const insertData = async (val: any) => {
        let { retData } = await userControlService.insert(val)
        globalPrompt('message', { text: '维保组合新增成功', type: 'success' })
        return retData
    }

    //表单编辑 Api
    const editData = async (val: any & { id: string }) => {
        let { retData } = await userControlService.update(val)
        globalPrompt('message', { text: '维保组合编辑成功', type: 'success' })
        return retData
    }

    return {
        /***field***/
        editFormVal,
        addFormVal,
        searchParam,
        dataSource,
        selectedRowKeys,
        pgCfg,
        userDetailVisible,
        /***method***/
        setUserDetailVisible,
        setDataSource,
        setSelectedRowKeys,
        resetSearchParam,
        updateSearchParam,
        loadData,
        updateAddFormVal,
        updateEditFormVal,
        insertData,
        editData,
        getOne,
    }
})
